export default __webpack_public_path__ + "static/media/up-arrow.bd9aa079.svg";